module.exports = __webpack_public_path__ + "static/media/m_faceshape_diamond.ed53d5cf.png";